module.exports = __webpack_public_path__ + "img/2_113.1f887693.png";